import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconHamburgerNew: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props} fill="none">
      <path
        d="M1 1H17M1 7H11M1 13H5"
        stroke={props.fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export default IconHamburgerNew;
